export const costs = [
  'You learn switchboards, MCCs and switchgear from scattered manuals, random videos and drawings that are always out of date',
  "You don't fully understand why breakers trip, how protection is coordinated or how MV switchgear really works, so every fault and shutdown feels stressful",
  'Distribution systems, LV and MV equipment, protection, testing and electrical safety are never explained in one clear place',
  'You lack the time to build a complete, coherent understanding of how the whole distribution system works together',
];
